
import { Component, Watch, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import { earliestPickupTimes, latestPickupTimes, pickUpLocations } from '@/features/common/raw';
import { UserPreferences } from '@/features/settings/types';
import { patchPreferences } from '@/features/settings/services/preferences.services';
import { useConvertTime } from '@/features/common/helpers';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { PreferencesMixin } from './mixins';

@Component
export default class SchedulePickup extends Mixins(PreferencesMixin, ResponsivenessMixin) {
  private earliestPickupTimes = earliestPickupTimes;

  private latestPickupTimes = latestPickupTimes;

  private pickUpLocations = pickUpLocations;

  private formSchedulePickup = {
    readyTime: '',
    closeTime: '',
    pickupLocation: '',
    pickupComments: '',
  }

  private showPickupPrefsAlert = {
    success: false,
    show: false,
  };

  get isUserPreferences(): number {
    return this.$store.getters.getIsUserPreferences;
  }

  get userPreferences(): UserPreferences {
    return this.$store.getters.getUserPreferences;
  }

  @Watch('isUserPreferences', { immediate: true })
  private populatePreferences(newValue: number) {
    if (newValue) {
      const { schedulePickup } = this.userPreferences;
      this.formSchedulePickup.readyTime = useConvertTime(
        schedulePickup.readyTime, earliestPickupTimes[0],
      ) || earliestPickupTimes[0];
      this.formSchedulePickup.closeTime = useConvertTime(schedulePickup.closeTime)
        || this.latestPickupTimes[10];
      this.formSchedulePickup.pickupLocation = schedulePickup.location
        || this.pickUpLocations[0].value;
      this.formSchedulePickup.pickupComments = schedulePickup.comments ?? '';
      return;
    }

    [this.formSchedulePickup.readyTime] = earliestPickupTimes;
    // eslint-disable-next-line prefer-destructuring
    this.formSchedulePickup.closeTime = this.latestPickupTimes[10];
    this.formSchedulePickup.pickupLocation = this.pickUpLocations[0].value;
  }

  private async updateSchedulePreference({ path, value }: {
    path: string,
    value: unknown,
  }) {
    let payloadValue = value;

    if (['readyTime', 'closeTime'].includes(path)) {
      if (value === earliestPickupTimes[0]) {
        payloadValue = null;
      } else {
        payloadValue = moment(value as string, 'h:mm A')
          .local()
          .format('YYYY-MM-DDTHH:mm:ss');
      }
    }

    this.patchPreferenceInStore(`schedulePickup/${path}`, payloadValue);

    const response = await patchPreferences(this.userPreferences.id, [
      {
        path: `schedulePickup/${path}`,
        op: 'replace',
        value: payloadValue,
      },
    ]);

    this.showPickupPrefsAlert = {
      show: true,
      success: !!response,
    };
  }
}
